/** @jsx jsx */
import { jsx } from '@emotion/core';
import { stripTrailingSlash } from '@zapier/url-utils';

import type { AppSummary as AppSummaryType } from 'app/developer-v3/types';

import ByCliToolMessage from '../ByCliToolMessage';
import Menu from './Menu';
import { SidebarEmbedKey, SidebarEmbedName } from './types';
import { Icon } from '@zapier/zinnia-icons';

type Props = {
  appSummary: AppSummaryType;
  versionlessUrl: string;
  currentUrl: string;
};

export default function SectionEmbed({
  versionlessUrl,
  currentUrl,
  appSummary,
}: Props): JSX.Element {
  const itemPropsArray = [
    {
      item: {
        badge: null,
        isActive: stripTrailingSlash(currentUrl).endsWith(
          `${versionlessUrl}/${SidebarEmbedKey.embed}`
        ),
        isEnabled: true,
        label: SidebarEmbedName.embed,
        section: 'embed' as const,
        url: `${versionlessUrl}/${SidebarEmbedKey.embed}`,
      },
      key: SidebarEmbedKey.embed,
    },
  ];

  if (!appSummary.isPrivate) {
    itemPropsArray.push(
      {
        item: {
          badge: <Icon name="arrowOffsite" size={16} />,
          isActive: stripTrailingSlash(currentUrl).endsWith(
            `${versionlessUrl}/${SidebarEmbedKey.workflowElement}`
          ),
          isEnabled: true,
          label: SidebarEmbedName.workflowElement,
          section: 'embed' as const,
          url: `${versionlessUrl}/${SidebarEmbedKey.workflowElement}`,
        },
        key: SidebarEmbedKey.workflowElement,
      },
      {
        item: {
          badge: <Icon name="arrowOffsite" size={16} />,
          isActive: stripTrailingSlash(currentUrl).endsWith(
            `${versionlessUrl}/${SidebarEmbedKey.workflowApi}`
          ),
          isEnabled: true,
          label: SidebarEmbedName.workflowApi,
          section: 'embed' as const,
          url: `https://docs.zapier.com/powered-by-zapier/zap-creation/getting-started`,
        },
        key: SidebarEmbedKey.workflowApi,
      },
      {
        item: {
          badge: null,
          isActive: stripTrailingSlash(currentUrl).endsWith(
            `${versionlessUrl}/${SidebarEmbedKey.zapPrefillGenerator}`
          ),
          isEnabled: true,
          label: SidebarEmbedName.zapPrefillGenerator,
          section: 'embed' as const,
          url: `${versionlessUrl}/${SidebarEmbedKey.zapPrefillGenerator}`,
        },
        key: SidebarEmbedKey.zapPrefillGenerator,
      },
      {
        item: {
          badge: null,
          isActive: stripTrailingSlash(currentUrl).includes(
            `${versionlessUrl}/${SidebarEmbedKey.settings}`
          ),
          isEnabled: true,
          label: SidebarEmbedName.settings,
          section: 'embed' as const,
          url: `${versionlessUrl}/${SidebarEmbedKey.settings}`,
        },
        key: SidebarEmbedKey.settings,
      }
    );
  }

  return (
    <Menu
      disabledMessage={<ByCliToolMessage theme="dark" />}
      hasTopBorder={true}
      itemsProps={itemPropsArray}
      menuKey="embed"
      title="Embed"
      titleIconName="partnerEmbed"
    />
  );
}
